export const WDAC_POLICY_PURPOSE = {
  UnmatchedFiles: 'UnmatchedFiles',
  PackagedApps: 'PackagedApps',
  Win32Apps: 'Win32Apps',
};

const WDAC_POLICY_PURPOSE_MAPPING = [
  { value: WDAC_POLICY_PURPOSE.UnmatchedFiles, label: 'Unmatched Files' },
  { value: WDAC_POLICY_PURPOSE.PackagedApps, label: 'Packaged Apps' },
  { value: WDAC_POLICY_PURPOSE.Win32Apps, label: 'Win32 Apps' },
];

export const getWdacPolicyPurposeLabel = value =>
  WDAC_POLICY_PURPOSE_MAPPING.find(item => item.value === value)?.label ?? '';

export const getWdacPolicyPurposeOptions = () =>
  WDAC_POLICY_PURPOSE_MAPPING.map(({ value, label }) => ({ value, label }));
